import { Component } from '@angular/core';

@Component({
  templateUrl: './login.component.html'
})
export class LoginComponent {}



// WEBPACK FOOTER //
// /srv/src/app/auth/login.component.ts